import { render, staticRenderFns } from "./BookingForm.vue?vue&type=template&id=d6faed0a"
import script from "./BookingForm.vue?vue&type=script&lang=js"
export * from "./BookingForm.vue?vue&type=script&lang=js"
import style0 from "./BookingForm.vue?vue&type=style&index=0&id=d6faed0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports